/* eslint-disable @typescript-eslint/no-unused-vars */
import React from 'react';
import { checkValue } from 'src/components/common/helper';
import { CpdsVideoProps } from './typings';
import { VideoProps } from 'components/common/modules/video-player/video';
import { Cpds } from '@Cpds.Ui';
import useAkamaiVideo from 'components/common/modules/hooks/useAkamaiVideo';
import YouTubePlayer from './youtube-player';
import VimeoPlayer from './vimeo-player';
import { VideoContainer, Player } from './styles/cpds-video';

export const hasVideoData = (data: any) => data?.videoUrl || data?.youtubeId || data?.vimeoId || data?.akamaiVideo;

export const getYouTubeVideoId = (url: string): string | null => {
  if (!url) return null;

  const youtubeRegex =
    /^(https?:\/\/)?(www\.)?(youtube\.com|youtu\.be|youtube-nocookie\.com)\/(watch\?v=|embed\/|v\/|.+\?v=)?([^&?/=\s]{11})/;
  const match = url.match(youtubeRegex);
  return match ? match[5] : url;
};

export const getVimeoVideoId = (url: string): string | null => {
  if (!url) return null;

  const vimeoRegex =
    /(?:https?:\/\/)?(?:www\.)?(vimeo\.com\/(?:channels\/\w+\/|groups\/\w+\/videos\/|album\/\d+\/video\/|video\/|)(\d+))/;
  const match = url.match(vimeoRegex);
  return match ? match[2] : url;
};

const CpdsVideo: React.FC<CpdsVideoProps> = (props) => {
  const {
    youtubeId,
    vimeoId,
    poster,
    akamaiVideo,
    playBtnColor,
    onTimeUpdate,
    videoUrl,
    exClass,
    autoPlay = false,
    muted = false,
    loop = true,
    playsInline = true,
    heroScrollDownArrow = true,
    hideVideoPlayControls = 'False',
    hideSoundControlsForVideo = false,
    customControlComponnet = Cpds.PlayButton.WithSoundsControls,
    aspectRatio,
    styleOverrides,
    altText,
    trackClickVideo,
    eventCategory = ''
  } = props;

  let video = '';
  if (videoUrl) video = videoUrl;
  else if (checkValue(akamaiVideo)) video = useAkamaiVideo(akamaiVideo?.video?.availableResources)?.url;

  const videoProps: VideoProps = {
    src: video,
    exClass: 'cpds-video-component',
    autoPlay,
    muted,
    loop,
    poster,
    playsInline,
    heroScrollDownArrow,
    hideVideoPlayControls,
    hideSoundControlsForVideo,
    customControlComponnet,
    onTimeUpdate,
    playBtnColor,
    altText,
    trackClickVideo,
    eventCategory
  };

  return (
    <VideoContainer
      className={`cpds-video-container ${exClass}`}
      aspectRatio={aspectRatio}
      styleOverrides={styleOverrides}
    >
      {getYouTubeVideoId(youtubeId) ? (
        <YouTubePlayer
          videoId={getYouTubeVideoId(youtubeId)}
          posterUrl={poster}
          altText={altText}
          playBtnColor={playBtnColor}
          trackClickVideo = {trackClickVideo}
          eventCategory = {eventCategory}
          playerVars={{
            playsinline: 1, // Play inline on mobile
            controls: 0, // Hide the control bar and the red play button
            modestbranding: 1, // Minimal branding
            showinfo: 0,
          }}
        />
      ) : getVimeoVideoId(vimeoId) ? (
        <VimeoPlayer
          videoId={getVimeoVideoId(vimeoId)}
          posterUrl={poster}
          altText={altText}
          playBtnColor={playBtnColor}
          playerOptions={{
            controls: false,
          }}
          trackClickVideo = {trackClickVideo}
          eventCategory = {eventCategory}
        />
      ) : (
        <Player {...videoProps} />
      )}
    </VideoContainer>
  );
};

export default CpdsVideo;
